module.exports = __webpack_public_path__ + "static/img/icon4.b0df710.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/icon4.png
// module id = UuDM
// module chunks = 1